import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { PRICE_EUR } from './Shared';
export function UrgencyBanner() {
  const [timeLeft, setTimeLeft] = useState({
    h: 1,
    m: 0,
    s: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-brand-purpleDark text-brand-surface border-b border-brand-gold/40" data-id="element-249" data-mp="3b5woagx05wta">
      <div className="max-w-7xl mx-auto px-3 py-2 md:px-6 md:py-2.5" data-id="element-250" data-mp="1gtydiaj1osva">
        <div className="md:hidden overflow-hidden relative" data-id="element-251" data-mp="1gwcaioxacf5h">
          <motion.div className="flex items-center gap-6 whitespace-nowrap text-[11px] font-medium w-max" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 20,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-252" data-mp="27frl6nzq9fiq">
            {[0, 1].map(dup => <div key={dup} className="flex items-center gap-6 shrink-0" data-id="element-253" data-mp="1sqbxjgvhtq79">
                <div className="flex items-center gap-1.5 shrink-0 text-brand-goldLight" data-id="element-254" data-mp="2qdkdkwcq671v">
                  <Clock className="w-3.5 h-3.5 shrink-0" data-id="element-255" data-mp="2qb7xkoqj26rg" />
                  <span data-id="element-256" data-mp="2lfslo2c2ykxo">Il prezzo di lancio si chiude tra</span>
                  <span className="font-mono font-bold tabular-nums border border-brand-gold/40 rounded-sm px-1.5 py-0.5 ml-0.5 text-white" data-id="element-257" data-mp="2gev6zzqa490x">
                    {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
                  </span>
                </div>
                <span className="w-1 h-1 rotate-45 bg-brand-goldLight/60 shrink-0" data-id="element-258" data-mp="14y4xo7qk7133" />
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-259" data-mp="10xcm37u7sk3n">
                  <span className="w-1.5 h-1.5 rounded-full bg-brand-burgundy animate-pulse" data-id="element-260" data-mp="12gurnodslzaz" />
                  <span data-id="element-261" data-mp="17f5z5sgm7xq1">
                    Prezzo di lancio{' '}
                    <strong className="text-brand-goldLight" data-id="element-262" data-mp="shnccvnhzul8">{PRICE_EUR}</strong>
                  </span>
                </div>
                <span className="w-1 h-1 rotate-45 bg-brand-goldLight/60 shrink-0" data-id="element-263" data-mp="xfxa9e0lx9aj" />
                <a href="#pricing" className="inline-flex items-center gap-1 border border-brand-goldLight/70 text-brand-goldLight font-semibold uppercase tracking-wider px-2.5 py-0.5 rounded-sm text-[10px] shrink-0" data-id="element-264" data-mp="jos7i31y00vz">
                  Vedi il pack
                </a>
              </div>)}
          </motion.div>
        </div>

        <div className="hidden md:flex items-center justify-center gap-6 text-xs font-medium" data-id="element-265" data-mp="era7511zqtzl">
          <div className="flex items-center gap-2 whitespace-nowrap text-brand-goldLight uppercase tracking-wider" data-id="element-266" data-mp="rim4gd24dc3">
            <Clock className="w-4 h-4 shrink-0" data-id="element-267" data-mp="4rjbux5lwayg" />
            <span data-id="element-268" data-mp="3i8v7xoib4de4">Il prezzo di lancio si chiude tra</span>
            <span className="font-mono font-bold tabular-nums border border-brand-gold/40 rounded-sm px-2 py-0.5 text-white normal-case" data-id="element-269" data-mp="3i9es7bvfjdvb">
              {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
            </span>
          </div>
          <div className="w-px h-4 bg-brand-goldLight/30 shrink-0" data-id="element-270" data-mp="3mb00sl0xl5zp" />
          <div className="flex items-center gap-2 whitespace-nowrap" data-id="element-271" data-mp="3mculpzc7cy3s">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-burgundy animate-pulse" data-id="element-272" data-mp="51bnpmjjncem" />
            <span className="text-brand-surface/85" data-id="element-273" data-mp="2gxw0n5snl0">
              Prezzo di lancio{' '}
              <strong className="text-brand-goldLight" data-id="element-274" data-mp="dv6l28efbyjp">{PRICE_EUR}</strong>
            </span>
          </div>
          <a href="#pricing" className="inline-flex items-center gap-1 border border-brand-goldLight/70 text-brand-goldLight font-semibold uppercase tracking-wider px-3 py-1 rounded-sm text-[10px] hover:bg-brand-goldLight hover:text-brand-purpleDark transition-colors shrink-0" data-id="element-275" data-mp="9ueanbttfnlu">
            Vedi il pack
          </a>
        </div>
      </div>
    </div>;
}